import { defineCollection } from "@rebasepro/cms-types";
import { personName, playerOf } from "../people";
import { day } from "../words";

// A Daily Gig started (songbuzz_solo_attempt): the server hands out a ticket when a go starts, one per account or
// device and day, and only that ticket's score counts. backend/functions/songbuzz.ts creates and writes it.
const dailyAttemptsCollection = defineCollection({
    name: "Daily Gig attempts",
    singularName: "Daily Gig attempt",
    slug: "daily_attempts",
    table: "songbuzz_solo_attempt",
    description: "Every Daily Gig started: who, which day, whether it was finished and ranked.",
    securityRules: [{ operation: "select", roles: ["admin"] }],
    properties: {
        day: { name: "Day", type: "string", isId: "manual", admin: { readOnly: true, Preview: "../../admin/src/previews/Words", customProps: { say: "day" } } },
        // the account ("u:<uid>") or, for Solo without one, the device
        who: { name: "Player id", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        player: playerOf("Player", "who", "player"),
        token: { name: "Ticket", type: "string", validation: { required: true }, admin: { readOnly: true, hideFromCollection: true } },
        startedAt: { name: "Started", type: "date", autoValue: "on_create", validation: { required: true }, admin: { readOnly: true } },
        finishedAt: { name: "Finished", description: "Empty: they left before the end", type: "date", admin: { readOnly: true } },
        ranked: { name: "Counts on the board", description: "Signed in, so the score goes on the ranked board", type: "boolean", admin: { readOnly: true } },
    },
    admin: {
        icon: "Ticket",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["startedAt", "desc"],
        display: {
            title: async ({ entity, context }) => personName(context, entity.values.who),
            subtitle: ({ entity }) => `Daily Gig · ${day(entity.values.day)}`,
            status: ({ entity }) => entity.values.finishedAt ? "Finished" : "Not finished",
            date: "startedAt",
        },
        listProperties: ["day", "finishedAt", "ranked", "startedAt"],
        form: {
            sections: [
                { key: "attempt", properties: ["player", "day", "startedAt", "finishedAt", "ranked"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["who", "token"] },
            ],
        },
    },
});

export default dailyAttemptsCollection;
